import React from 'react';
import { Input, DatePicker, Icon, Row, Col, Select, Tag } from 'antd';
import moment from 'moment';
import SelectPlaceHolder from '../../../components/SelectPlaceHolder';
import auth from "../../../common/utility/auth";
import { VER_SERIES_VENTA } from '../../../common/types/configuracionType';

class Filters extends React.Component {


    clsAlphaNoOnly(e) {  // Accept only alpha numerics, no special characters 
        var regex = new RegExp("^[a-zA-Z0-9 ]+$");
        var str = String.fromCharCode(!e.charCode ? e.which : e.charCode);
        if (regex.test(str)) {
            return true;
        }

        e.preventDefault();
        return false;
    }

    render() {
        var flagSerie = this.props.configuraciones.filter((m) => m.abreviatura === VER_SERIES_VENTA).length >= 1 ? false : true;

        return (
            <div className="filfer-container">
                <Row gutter={16}>
                    {/*                   <Col className="gutter-row" sm={24} md={12} lg={8}>
                        <Select
                            showSearch labelInValue
                            value={
                                this.props.filter.idCliente ?
                                    { key: this.props.filter.idCliente } : undefined
                            }
                            placeholder={<SelectPlaceHolder label="Filtrar por cliente" />}
                            onChange={(option) => this.props.onChange("idCliente", option.key)} //STATE PROPERTY
                            loading={this.props.filter.clienteLoading}
                            optionFilterProp="children"
                        >
                            {this.props.clientes.map(item => ( //STATE DATA
                                <Select.Option value={item.id} key={item.id}> <Tag>{item.tipoDocumentoNombre}</Tag>{`${item.nombre}-${item.numeroDocumento}`}</Select.Option>
                            ))}
                        </Select>
                    </Col> */}
                    <Col className="gutter-row" sm={24} md={12} lg={8}>
                        <Input
                            prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                            value={this.props.filter.cliente}
                            onChange={(e) => this.props.onChange("cliente", e.target.value)}
                            placeholder="Filtrar por cliente, Ruc"
                            autoComplete="off"
                            onKeyUp={this.props.onKeyUpSearch}

                        />
                    </Col>

                    {this.props.flagEmpresaTaller ?

                        <Col className="gutter-row" sm={24} md={12} lg={3}>
                            <Input
                                prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                                value={this.props.filter.placa}
                                onChange={(e) => this.props.onChange("placa", e.target.value)}
                                placeholder="Filtrar por placa"
                                autoComplete="off"
                                onKeyPress={(e) => this.clsAlphaNoOnly(e)}
                            />
                        </Col> : null
                    }


                    <Col className="gutter-row" sm={24} md={12} lg={4}>
                        <Select
                            showSearch labelInValue
                            value={
                                this.props.filter.idEstado ?
                                    { key: this.props.filter.idEstado } : undefined
                            }
                            placeholder={<SelectPlaceHolder label="Filtrar por Estado" />}
                            onChange={(option) => this.props.onChange("idEstado", option.key, option, 'estado')}

                            loading={this.props.filter.clienteLoading}
                            optionFilterProp="children"
                        >
                            <Select.Option value="0" key="0">TODOS</Select.Option>
                            {this.props.estado.map(item => ( //STATE DATA
                                <Select.Option value={item.id} key={item.id}  >{item.nombre}</Select.Option>
                            ))}
                        </Select>
                    </Col>

                    <Col className="gutter-row" sm={24} md={12} lg={3}>
                        <Input
                            disabled={flagSerie && this.props.nota == undefined}
                            prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                            value={this.props.filter.serie}
                            onChange={(e) => this.props.onChange("serie", e.target.value)}
                            onKeyUp={this.props.onKeyUpSearch}
                            placeholder="Filtrar por serie"
                            autoComplete="off"
                        />
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={3}>
                        <Input
                            prefix={<Icon type="filter" style={{ color: 'rgba(0,0,0,.25)' }} />}
                            value={this.props.filter.documento}
                            onChange={(e) => this.props.onChange("documento", e.target.value)}
                            onKeyUp={this.props.onKeyUpSearch}
                            placeholder="Filtrar por documento"
                            autoComplete="off"
                        />
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={3}>
                        <DatePicker
                            placeholder="Filtrar por fecha inicio"
                            format="DD/MM/YYYY"
                            value={this.props.filter.fechaInicioStr === '' ? null : moment(this.props.filter.fechaInicioStr, 'DD/MM/YYYY')}
                            onChange={(moment, value) => this.props.onChange('fechaInicioStr', value)}
                        />
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={3}>
                        <DatePicker
                            placeholder="Filtrar por fecha fin"
                            format="DD/MM/YYYY"
                            value={this.props.filter.fechaFinStr === '' ? null : moment(this.props.filter.fechaFinStr, 'DD/MM/YYYY')}
                            onChange={(moment, value) => this.props.onChange('fechaFinStr', value)}
                        />
                    </Col>
                    <Col className="gutter-row" sm={24} md={12} lg={4}>
                        <Select
                            showSearch labelInValue
                            value={
                                this.props.filter.idProyecto ?
                                    { key: this.props.filter.idProyecto } : undefined
                            }
                            placeholder={<SelectPlaceHolder label="Filtrar por Proyecto" />}
                            onChange={(option) => this.props.onChange("idProyecto", option.key, option, 'proyecto')}

                            loading={this.props.filter.clienteLoading}
                            optionFilterProp="children"
                        >
                            <Select.Option value="0" key="0">TODOS</Select.Option>
                            {this.props.proyectos.map(item => ( //STATE DATA

                                <Select.Option value={item.id} key={item.id}  >{item.nombre}</Select.Option>

                            ))}
                        </Select>
                    </Col>

                    <Col className="gutter-row" sm={24} md={12} lg={4}>
                        <Select
                            showSearch labelInValue
                            value={
                                this.props.filter.idVendedor ?
                                    { key: this.props.filter.idVendedor } : undefined
                            }
                            placeholder={<SelectPlaceHolder label="Filtrar por Vendedor" />}
                            onChange={(option) => this.props.onChange("idVendedor", option.key, option, 'vendedor')}

                            loading={this.props.filter.clienteLoading}
                            optionFilterProp="children"
                        >
                            <Select.Option key={0} value={0}>
                                <span style={{ color: "#bfbfbf" }}>Ninguno</span>
                            </Select.Option>
                            {this.props.vendedores.map((item) => (
                                <Select.Option key={item.id} value={item.id}>
                                    {item.razonSocialEntidad}
                                </Select.Option>
                            ))}
                        </Select>
                    </Col>
                    {this.props.formasPago === undefined ? null :

                        <Col className="gutter-row" sm={24} md={12} lg={4}>
                            <Select
                                showSearch labelInValue
                                value={
                                    this.props.filter.idFormaPago ?
                                        { key: this.props.filter.idFormaPago } : undefined
                                }
                                placeholder={<SelectPlaceHolder label="Filtrar por Forma Pago" />}
                                onChange={(option) => this.props.onChange("idFormaPago", option.key, option, 'FormaPago')}

                                loading={this.props.filter.clienteLoading}
                                optionFilterProp="children"
                            >
                                <Select.Option key={0} value={0}>
                                    <span style={{ color: "#bfbfbf" }}>Ninguno</span>
                                </Select.Option>
                                {this.props.formasPago.map((item) => (
                                    <Select.Option key={item.id} value={item.id}>
                                        {item.nombre}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Col>
                    }
                    {this.props.nota ?

                        <Col className="gutter-row" sm={24} md={12} lg={4}>
                            <Select
                                showSearch labelInValue
                                value={
                                    this.props.filter.idMotivo ?
                                        { key: this.props.filter.idMotivo } : undefined
                                }
                                placeholder={<SelectPlaceHolder label="Filtrar por Motivo" />}
                                onChange={(option) => this.props.onChange("idMotivo", option.key, option, 'motivo')}

                                loading={this.props.filter.clienteLoading}
                                optionFilterProp="children"
                            >
                                <Select.Option key={0} value={0}>
                                    <span style={{ color: "#bfbfbf" }}>Ninguno</span>
                                </Select.Option>
                                {this.props.motivos.map((item) => (
                                    <Select.Option key={item.id} value={item.id}>
                                        {item.nombre}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Col> : null
                    }
                </Row>
            </div>
        );
    }

}

export default Filters;